import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTheme } from 'styled-components';
import update from 'immutability-helper';

import { CardContainer, Flex, FlexColumn } from '../../Reusable/Container';
import PageHeader from '../../Reusable/PageHeader';
import { debounce } from 'lodash';
import { addressObjectToMultiLineStr, addressObjectToStr, getCodatPlatformName, isCodatUser, isEmailValid } from '../../../Utils/util';
import { ErrorAlert } from '../../Reusable/Alert';
import { Text } from '../../Reusable/Text';
import { LabeledInput } from '../../Reusable/Input';
import FlowFooter from '../../Reusable/FlowFooter';
import styled from 'styled-components';
import { apiPOSTReq } from '../../../Utils/api';
import environment from '../../../environment';
import Banner from '../../Reusable/Banner';
import LucideIcon, { Button, TextButton } from '../../Reusable/Button';
import TableView from '../../Reusable/TableView';
import { List, Popconfirm, Skeleton, Tag } from 'antd';
import { Eye, LucideDelete, Pencil, Trash } from 'lucide-react';
import { CheckCircleFilled, DeleteOutlined, EditOutlined } from '@ant-design/icons';
import AddPaymentMethod from './AddPaymentMethod';
import NewPaymentMethod from './NewPaymentMethod';
import AlertModal from '../../Reusable/AlertModal';
import { SignedLink } from '../../Reusable/Link';
import hexToRgba from 'hex-to-rgba';
import StepHeader from '../../Reusable/StepHeader';
import StepProgressIndicator from '../../Reusable/StepProgressIndicator';
import DocumentUploadModal from './DocumentUploadModal';

const flowViewsData = [{
    "FlowStep": "Vendor.BasicInfo",
    "Description": "Provide some basic information for this vendor",
    "ButtonTitle": "SAVE AND CONTINUE",
    "Step": "Basic information",
    "ValidationErrorMessage": "Please fill all required information."
},{
    "FlowStep": "Vendor.ContactInfo",
    "Description": "Add any contact information for the vendor",
    "ButtonTitle": "SAVE AND CONTINUE",
    "Step": "Contact information",
    "ValidationErrorMessage": "Please fill all required information."
},{
    "FlowStep": "Vendor.PM",
    "Description": "Add payment information for this vendor",
    "ButtonTitle": "SAVE AND CONTINUE",
    "Step": "Payment information",
    "ValidationErrorMessage": "Please fill all required information.",
},{
    "FlowStep": "Vendor.Docs",
    "Description": "Add W-9s or any other relevant documents",
    "ButtonTitle": "DONE",
    "Step": "Manage your documents",
    "ValidationErrorMessage": "Please fill all required information."
}];

class NewVendor extends Component {

    constructor(props) {
        super(props)
        const vendor = props.vendor || {}
        vendor.billRecipientEmail = vendor.billRecipientEmail || [];
        if(!vendor.type) vendor.type = "Business";

        this.state = {
            currentViewIndex: 0,
            maxCompletedIndex: 0, // Track the furthest step reached
            flowViews: flowViewsData,
            submitLoading: false,
            loading: false,
            vendor: vendor,
            paymentMethods: []
        }
    }

    saveVendor = (options, callback) => {
        var { fetchPM } = options || {};
        var { vendor } = this.state;
        const { vendorName, primaryEmail, type } = vendor;

        var successMessage = vendor.id ? "Vendor updated successfully!" : "Vendor created successfully!"

        if (!type) {
            ErrorAlert({ description: "Please select a type for this vendor." })
            return
        }

        if (!vendorName) {
            ErrorAlert({ description: "Please enter a vendor name." })
            return
        }

        if (vendorName.includes('|')) {
            ErrorAlert({ description: "Please enter a valid vendor name." })
            return
        }

        if (primaryEmail && !isEmailValid(primaryEmail)) {
            ErrorAlert({ description: "Please enter a valid email." })
            return
        }

        if (vendor.primaryEmail === "") {
            vendor.primaryEmail = null
        }

        this.setState({ loading: true })

        const body = {
            "vendor": vendor
        }

        apiPOSTReq(`${environment.payBaseUrl}/payables/vendors/save`, { "BankProvider": environment.bankProvider.crb }, body, (err, resp) => {
            try {
                this.setState({ loading: false })
                const data = resp
                console.log("/payables/vendors/save", data)
                if (data.result) {
                    this.setState({ vendor: data.vendor, editvendor: data.editvendor, createVendorLoading: false });
                    if(fetchPM) this.getPaymentMethods();
                    if(callback) callback(null, { vendor: data.vendor });
                } else {
                    throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later")
                }
            } catch (error) {
                this.setState({ loading: false });
                ErrorAlert({ description: error.message });
                if(callback) callback(error.message);
            }
        })
    }

    getPaymentMethods = (options) => {
        options = options || {}
        var { vendor } = this.state
        if (options.vendor) vendor = options.vendor
        if (!vendor.associatedCPObjectId) {
            if(vendor.id) this.searchExistingRecipients(vendor.vendorName);
            return
        }
        const body = {
            "vendorId": vendor.associatedCPObjectId
        }
        this.setState({ loading: true })
        apiPOSTReq(`${environment.payBaseUrl}/payables/vendors/getPaymentMethods`, { "BankProvider": environment.bankProvider.crb }, body, (err, resp) => {
            try {
                this.setState({ loading: false, pmLoading: false })
                const data = resp
                if (data.result) {
                    var paymentMethods = data.paymentMethods || [];
                    this.setState({ paymentMethods: paymentMethods });
                    this.scrollIntoView();
                } else {
                    throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later")
                }
            } catch (error) {
                console.log("ERRR getPaymentMethods", error, resp)
                ErrorAlert({ description: error.message })
            }
        })
    }

    handleOnKeyDown = (event) => { if(event.key === "Enter") this.loadNext() }

    // Validate input and go to next view if it's good
    loadNext = () => {
        var stateToSave = this.state;
        var { flowViews, currentViewIndex, vendor } = stateToSave;
        var flowView = flowViews[currentViewIndex];
        var validation = this.validateFlow();
        
        if (validation.validated) {
            // Save the data and load next
            switch (flowView.FlowStep) {
                case "Vendor.BasicInfo":
                    this.saveVendor(null, (err, resp) => {
                        if(!err) {
                            if(this.props.onVendorSave) {
                                this.props.onVendorSave(resp?.vendor);
                            }
                            this.loadNextView();
                        }
                    });
                    this.searchExistingRecipients(vendor.vendorName);
                    return;
                case "Vendor.Docs":
                    this.saveVendor(null, (err, resp) => {
                        if(this.props.onVendorSave) {
                            this.props.onVendorSave(vendor, true);
                        } else {
                            this.props.history.push({
                                pathname: '/payables/vendors'
                            });
                            this.props.history.push({
                                pathname: '/payables/vendors/details',
                                state: { vendor: vendor }
                            });
                        }
                        
                    });
                    return           
                default:
                    this.saveVendor(null, (err, resp) => {
                        if(!err) this.loadNextView();
                    });
                    return;
            }
        } else {
            if(validation.showErrorModal) ErrorAlert({ description: validation.message });
        }
    }

    validateFlow = () => {
        var { flowViews, currentViewIndex, paymentMethods, skipAddPM } = this.state;
        var flowView = flowViews[currentViewIndex];
        if(!flowView.UserInput) {
            // Check if default exists
            if(flowView.DefaultUserInput) flowView.UserInput = flowView.DefaultUserInput;
        }
        var validation = {
            validated: false,
            message: flowView.ValidationErrorMessage ?? "Please provide an input to continue",
            showErrorModal: false
        }

        var { vendor } = this.state;
        const { vendorName, primaryEmail, type } = vendor;

        switch (flowView.FlowStep) {
            case "Vendor.BasicInfo":
                if (!type) {
                    this.setState({
                        errorMessage: "Please select a type for this vendor.",
                        errorField: "type"
                    });
                    return validation;
                } 
                if (!vendorName || vendorName.includes('|')) {
                    this.setState({
                        errorMessage: "Please enter a valid vendor name.",
                        errorField: "vendorName"
                    });
                    return validation;
                }
                validation.validated = true;
                break;
            case "Vendor.ContactInfo":
                if (primaryEmail && !isEmailValid(primaryEmail)) {
                    this.setState({
                        errorMessage: "Please enter a valid email.",
                        errorField: "primaryEmail"
                    });
                    return validation;
                }
                validation.validated = true;
                break;
            case "Vendor.PM":
                if(paymentMethods.length == 0 && !skipAddPM) {
                    this.setState({
                        showNoPMAlert: true
                    });
                    return validation;
                }
                validation.validated = true;
                break;
            case "Vendor.Docs":
                validation.validated = true;
                break;
            default:
                if(flowView.UserInput || flowView.DefaultUserInput) validation.validated = true;
                break;
        }
        this.setState({ flowViews: flowViews });
        if(!validation.validated) validation.showErrorModal = true;
        else this.setState({ errorField: null });
        return validation;
    }

    loadPrevView = () => {
        let { flowViews, currentViewIndex } = this.state;
        if (currentViewIndex !== 0) {
            this.setState({
                currentViewIndex: currentViewIndex - 1,
                flowViews: flowViews,
                flowView: flowViews[currentViewIndex - 1],
                showError: false, errorMsg: ""      // dismiss any validatin error, if any, for the current step
            });
        }
    }

    loadNextView = () => {
        const { currentViewIndex, maxCompletedIndex } = this.state;
        const nextIndex = currentViewIndex + 1;
        
        if (nextIndex < flowViewsData.length) {
            this.setState({
                currentViewIndex: nextIndex,
                // Update maxCompletedIndex if we're moving to a new step
                maxCompletedIndex: Math.max(maxCompletedIndex, nextIndex)
            });
        }
    }

    handleEditStep = (flowStep) => {
        const stepIndex = flowViewsData.findIndex(flowView => (flowView.FlowStep == flowStep));
        // Allow editing only completed steps
        if (stepIndex <= this.state.maxCompletedIndex) {
            this.setState({
                currentViewIndex: stepIndex
            });
        }
    }

    syncCPWithVendor = () => {
        var { existingCP, vendor } = this.state;
        if(!vendor.id) vendor.vendorName = existingCP.nameOnAccount;
        vendor.associatedCPObjectId = existingCP.objectId;
        this.setState({ vendor, existingCP: null, pmLoading: true }, this.saveVendor({ fetchPM: true }));
    }

    saveVendorInput = (key, value) => {
        var { vendor } = this.state
        vendor[key] = value
        this.setState({ vendor })
    }

    debouncedSearch = debounce((searchTerm) => {
        if ((searchTerm || "").length > 2) {
            this.searchExistingRecipients(searchTerm);
        } else {
            this.setState({ existingCP: null });
        }
    }, 500);

    searchExistingRecipients = (name) => {
        var { vendor } = this.state;
        var body = {
            "searchStr": name,
            "viewBy": "BusinessBanking" // Only returns CPs with this source application
        }
        if(vendor.type) {
            body.type = vendor.type;
        }
        this.setState({ searchLoading: true });
        apiPOSTReq(`${environment.integrationBaseUrl}/integration/semanticSearch/getBBCounterparties`, {}, body, (err, resp) => {
            try {
                this.setState({ searchLoading: false });
                const data = resp;
                if (data.result) {
                    this.setState({ cpSearchResult: data.searchResult, existingCP: data.counterpartiesObj });
                } else {
                    throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later")
                }
            } catch (error) {
                console.log({ description: error.message });
            }
        })
    }

    handleVendorTextChange = (event) => {
        var { vendor } = this.state;

        const vendorName = event.target.value;
        vendor[event.target.id] = vendorName;
        // Trigger the debounced search
        // this.debouncedSearch(vendorName);
        this.setState({ vendor });
    }

    getVendorLocation = (location, formattedAddress) => {
        if (!location)
            this.setState({
                vendor: update(this.state.vendor, {
                    address: {
                        $set: {
                            line1: null,
                            line2: null,
                            city: null,
                            countrySubDivisionCode: null,
                            state: null,
                            postalCode: null
                        }
                    }
                })
            })
        else
            this.setState({
                vendor: update(this.state.vendor, {
                    address: {
                        $set: {
                            line1: location.line1,
                            line2: location.line2,
                            city: location.city,
                            countrySubDivisionCode: location.countrySubDivisionCode,
                            state: location.state,
                            postalCode: location.postalCode
                        }
                    }
                })
            })
    }

    render() {
        const { flowViews, currentViewIndex, edit, disabled, loading, showNoPMAlert } = this.state;
        var { contentWidth, theme, billFlow } = this.props;

        var flowView = flowViews[currentViewIndex];

        console.log("vendor", this.state.vendor);
        return (
            <FlexColumn className={!billFlow && 'main-padding'} style={{ height: billFlow ? '95%' : 'calc(108vh)' }}>
                <PageHeader
                    titleText={`${edit ? 'Edit' : 'New'} Vendor`}
                    back
                />
                <CardContainer 
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        flex: 1,
                        minHeight: 0,
                        boxShadow: billFlow && 'none',
                        padding: 0
                    }}
                    noShadow
                    padding='0px'
                >
                    <FlexColumn start style={{ flex: 1, minHeight: 0, marginTop: billFlow ? '20px' : '64px' }}>
                        <Flex start={billFlow} fullWidth style={{ padding: !billFlow && '20px' }}>
                            {/* <StepProgressIndicator 
                                steps={flowViews}
                                currentStep={flowView.FlowStep}
                            /> */}
                            <FlexColumn>
                                {this.getViews()}
                            </FlexColumn>
                        </Flex>
                    </FlexColumn>
                </CardContainer>
                <AlertModal
                    question
                    visible={showNoPMAlert}
                    loading={loading}
                    title='Are you sure you want to proceed without adding bank details?'
                    description={"You will be able to add this information later"}
                    // descWidth={'250px'}
                    buttonTitle='YES'
                    cancelButtonText='NO'
                    onConfirm={() => {
                        this.setState({ showNoPMAlert: false, skipAddPM: true }, this.loadNextView())
                    }}
                    onCancel={() => this.setState({ showNoPMAlert: false })}
                />
                <DocumentUploadModal
                    key={(this.state.vendor.attachments || []).length + 1}
                    visible={this.state.showUploadModal}
                    onClose={() => this.setState({ showUploadModal: false })}
                    onSave={(uploadedFile) => {
                        console.log("onSave attachment:", uploadedFile);
                        
                        // Ensure all required fields are present
                        if (!uploadedFile.fileName || !uploadedFile.type || !uploadedFile.uri) {
                            ErrorAlert({ description: "Missing required attachment information" });
                            return;
                        }
                        
                        // Create a copy of the current attachments or initialize an empty array
                        const currentAttachments = [...(this.state.vendor.attachments || [])];
                        
                        // Check if this is an update of an existing attachment
                        const existingIndex = currentAttachments.findIndex(
                            att => att.uri === uploadedFile.uri || att.type === uploadedFile.type
                        );
                        
                        if (existingIndex >= 0) {
                            // Update existing attachment
                            currentAttachments[existingIndex] = uploadedFile;
                        } else {
                            // Add new attachment
                            currentAttachments.push(uploadedFile);
                        }
                        
                        // Update vendor state with the new attachments array
                        this.setState({
                            vendor: {
                                ...this.state.vendor,
                                attachments: currentAttachments
                            },
                            showUploadModal: false
                        });
                    }}
                    doc={this.state.uploadDoc || {}}
                    businessKey={this.props.aionStore.BusinessUniqueKey}
                    jwt={this.props.aionStore.jwt}
                />
            </FlexColumn>
        )
    }

    getViews = () => {
        const { currentViewIndex, maxCompletedIndex } = this.state; 
        const visibleViews = flowViewsData.slice(0, maxCompletedIndex + 1);
        
        return (
            <FlexColumn 
                gap='16px' 
                style={{ 
                    maxHeight: 'calc(100vh - 100px)',
                    overflowY: 'auto',
                    padding: '0 4px'
                }}
            >
                {visibleViews.map((view, index) => {
                    const isCurrentStep = index === currentViewIndex;
                    return (
                        <FlexColumn 
                            gap={'16px'} 
                            start
                            key={view.FlowStep}
                            id={`step-${index}`}
                            style={{
                                transition: 'all 0.3s ease',
                                
                                transformOrigin: 'top center',
                            }}
                            
                        >
                            {this.getContentViews({ 
                                stepIndex: index,
                                readOnly: index !== currentViewIndex && index <= maxCompletedIndex
                            })}
                            {
                                (index == currentViewIndex) &&
                                this.getStepCTA({ stepIndex: index })
                            }
                        </FlexColumn>
                    );
                })}
            </FlexColumn>
        );
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.currentViewIndex !== this.state.currentViewIndex) {
            this.scrollIntoView();
        }
    }

    scrollIntoView = () => {
        const currentStepElement = document.getElementById(`step-${this.state.currentViewIndex}`);
        currentStepElement.scrollIntoView({ 
            behavior: 'smooth',
            block: 'nearest'
        });
    }

    getStepCTA = (options) => {
        const { flowViews, disabled, loading, paymentMethods, vendor } = this.state; 
        var { stepIndex } = options;
        const flowView = flowViews[stepIndex];

        var cta = <Button solid disabled={disabled} loading={loading} onClick={this.loadNext} text={flowView.ButtonTitle} style={{ width: flowView.ButtonTitle.length > 15 ? '220px' : '120px' }} />;

        switch(flowView.FlowStep) {
            case "Vendor.BasicInfo":
                if(vendor.id) return <Button solid disabled={disabled} loading={loading} onClick={this.loadNext} text={"SAVE AND CONTINUE"} style={{ width: '220px' }} />;
                else return cta;
                break
            case "Vendor.PM":
                var addrRequired = (paymentMethods || []).find(pm => pm.type == "Wire" && !pm.bankDetail?.addressOnAccount?.line1);
                if(paymentMethods.length > 0 && !addrRequired) return cta;
                break
            default:
                return cta;     
        }
    }

    getContentViews = (options) => {
        var { readOnly, stepIndex } = options;
        // readOnly = true
        const { flowViews, vendor, errorField, errorMessage, paymentMethods, existingCP, pmLoading } = this.state;
        const { theme, contentWidth, aionStore } = this.props;

        var { vendorName, address, type, primaryEmail, primaryPhone, billRecipientEmail, customerId } = vendor
        const flowView = flowViews[stepIndex];

        // console.log("getContentViews paymentMethods", paymentMethods)

        switch (flowView.FlowStep) {
            case "Vendor.BasicInfo":
                var stepContent = () => {
                    return (
                        <>
                            <LabeledInput
                                label="Type"
                                type={readOnly ? 'read-only' : 'switch'}
                                switchNames={['Business', 'Individual']}
                                onChange={(value) => this.saveVendorInput("type", value)}
                                value={type}
                                nomargin
                            />
                            <LabeledInput
                                autoFocus
                                label="Name"
                                labelcolor={theme.colors.secondary3}
                                id="vendorName"
                                key="vendorName"
                                placeholder="Enter vendor name"
                                value={vendorName}
                                onChange={this.handleVendorTextChange}
                                nomargin
                                onKeyDown={this.handleOnKeyDown}
                                error={errorField == "vendorName"}
                                errorMessage={errorMessage}
                                type={readOnly && 'read-only'}
                            />
                            {
                                !readOnly ?
                                <LabeledInput
                                    optional
                                    id="address"
                                    key="address"
                                    label="Address"
                                    labelcolor={theme.colors.secondary3}
                                    type={readOnly ? 'read-only' : "location"}
                                    getLocation={this.getVendorLocation}
                                    Line2
                                    address={address}
                                    value={address}
                                    placeholder="Address"
                                    nomargin
                                    error={errorField == "address"}
                                    errorMessage={errorMessage}
                                />
                                :
                                <LabeledInput
                                    type='read-only'
                                    label="Address"
                                    value={(address || {}).line1 ? addressObjectToStr(address) : '--'}
                                />
                            }
                        </>
                    )
                }
                return (
                    <FlexColumn gap='16px' start style={{ 
                        border: `1px solid ${hexToRgba(theme.colors.primary2, 0.1)}`, 
                        borderRadius: '8px', 
                        padding: '24px 36px', 
                        width: contentWidth || '850px',
                        minHeight: !readOnly && '500px'
                    }}>
                        <StepHeader 
                            step={flowView.Step} 
                            header={readOnly ? null : flowView.Description} 
                            cta={readOnly && <LucideIcon icon={Pencil} color={hexToRgba(theme.colors.primary2, 0.5)} size={16} onClick={() => this.handleEditStep(flowView.FlowStep)} />} 
                        />
                        {
                            !readOnly ? 
                                stepContent()
                            :
                            <Flex start centerH>
                                {stepContent()}
                            </Flex>
                        }
                        
                        
                    </FlexColumn>
                );
            case "Vendor.ContactInfo":
                var stepContent = () => {
                    return (
                        <>
                            <LabeledInput
                                optional
                                label="Email"
                                labelcolor={theme.colors.secondary3}
                                id="primaryEmail"
                                key="primaryEmail"
                                placeholder="Enter email"
                                value={primaryEmail || (readOnly ? '--' : null)}
                                onChange={this.handleVendorTextChange}
                                nomargin
                                error={errorField == "primaryEmail"}
                                errorMessage={errorMessage}
                                type={readOnly && 'read-only'}
                            />

                            <LabeledInput
                                optional
                                label="Phone"
                                labelcolor={theme.colors.secondary3}
                                id="primaryPhone"
                                key="primaryPhone"
                                placeholder="Enter phone number"
                                value={primaryPhone || (readOnly ? '--' : null)}
                                onChange={this.handleVendorTextChange}
                                maxLength={10}
                                nomargin
                                error={errorField == "primaryPhone"}
                                errorMessage={errorMessage}
                                type={readOnly && 'read-only'}
                            />
                        </>
                    )
                }
                return (
                    <FlexColumn gap='16px' start style={{ 
                        border: `1px solid ${hexToRgba(theme.colors.primary2, 0.1)}`, 
                        borderRadius: '8px', 
                        padding: '24px 36px', 
                        width: contentWidth || '850px',
                        minHeight: !readOnly && '500px'
                    }}>
                        <StepHeader 
                            step={flowView.Step} 
                            header={readOnly ? null : flowView.Description} 
                            cta={readOnly && <LucideIcon icon={Pencil} color={hexToRgba(theme.colors.primary2, 0.5)} size={16} onClick={() => this.handleEditStep(flowView.FlowStep)} />} 
                        />
                        {
                            !readOnly ? 
                                stepContent()
                            :
                            <Flex>
                                {stepContent()}
                            </Flex>
                        }
                    </FlexColumn>
                );
            case "Vendor.PM":
                var addrRequired = (paymentMethods || []).find(pm => pm.type == "Wire" && !pm.bankDetail?.addressOnAccount?.line1);

                var stepContent = () => {
                    return (
                        <>
                            {
                                existingCP ?
                                <Banner
                                    start 
                                    centerH 
                                    gap='8px' 
                                    message={
                                        <FlexColumn gap='4px'>
                                            <Text caption> We detected a potential match from your banking recipient list. Want to use the same bank details?</Text>
                                            <Text style={{ fontWeight: 500 }}>Name: {(existingCP || {}).nameOnAccount}</Text>
                                            <Flex start centerH gap='12px'>
                                                <TextButton onClick={() => this.syncCPWithVendor()} text='Yes' />
                                                <Text>OR</Text>
                                                <TextButton permtype="Payables.Vendors" onClick={() => this.setState({ existingCP: null, editPm: null })} text='Setup as New' />
                                            </Flex>
                                        </FlexColumn>
                                    }
                                />
                                :
                                (!readOnly || (paymentMethods.length > 0)) && <FlexColumn style={{ marginBottom: '32px' }}>
                                    <Skeleton loading={pmLoading} active title={false} paragraph={{ rows: 3 }}>
                                        <NewPaymentMethod
                                            vendor={vendor}
                                            // accountNumber={}
                                            // routingNumber={}
                                            onSave={(updatedVendor, pm) => {
                                                this.setState({ vendor: updatedVendor, paymentMethods: pm }, () => this.scrollIntoView());
                                            }}
                                            paymentMethods={paymentMethods}
                                            addressOnAccount={address}
                                        />
                                    </Skeleton>
                                </FlexColumn>
                            }
                            {
                                (paymentMethods.length > 0) && !addrRequired && !readOnly &&
                                <>
                                    <FlexColumn gap="8px">
                                        <Text size='18px' weight='600'>
                                            Identifiers and Notifications
                                        </Text>
                                        <Text color={theme.colors.defaultLightText}>
                                            Add any identifiers and people you would like to notify for payments
                                        </Text>
                                    </FlexColumn>
                                    <LabeledInput
                                        optional
                                        label={"Customer ID"}
                                        id="customerId"
                                        key="customerId"
                                        placeholder="Add an ID"
                                        value={customerId || (readOnly ? '--' : null)}
                                        onChange={this.handleVendorTextChange}
                                        nomargin
                                        maxLength='10'
                                        instruction="This ID will be automatically added when making a bill payment to help your vendors easily identify it"
                                        unsyncable={isCodatUser(aionStore)}
                                        accountingSoftware={getCodatPlatformName(aionStore)}
                                        type={readOnly && 'read-only'}
                                    />

                                    <LabeledInput
                                        label='Bill payment notification email'
                                        id="emails"
                                        key="emails"
                                        type={readOnly ? 'read-only' : "multi-email"}
                                        nomargin
                                        onChange={(billRecipientEmail) => {
                                            vendor.billRecipientEmail = billRecipientEmail
                                            this.setState({ vendor })
                                        }}
                                        onDelete={(index) => {
                                            var emails = []

                                            for (var i = 0; i < billRecipientEmail.length; i++) {
                                                if (i != index) emails.push(billRecipientEmail[i])
                                            }

                                            vendor.billRecipientEmail = emails
                                            this.setState({ vendor })
                                        }}
                                        emails={billRecipientEmail && billRecipientEmail}
                                        instruction="Email of the recipient(s) that will receive bill payment notifications"
                                        unsyncable={isCodatUser(aionStore)}
                                        accountingSoftware={getCodatPlatformName(aionStore)}
                                        optional
                                    />
                                </>
                            }
                        </>
                    )
                }
                return (
                    <FlexColumn key={paymentMethods.length} gap='16px' start style={{ 
                        border: `1px solid ${hexToRgba(theme.colors.primary2, 0.1)}`, 
                        borderRadius: '8px', 
                        padding: '24px 36px', 
                        width: contentWidth || '850px',
                        minHeight: !readOnly && '500px'
                    }}>
                        <StepHeader 
                            step={flowView.Step}
                            header={readOnly ? null : (paymentMethods.length == 0) ? flowView.Description : 'Successfully added! Setup any identifiers and notifications'}
                            cta={readOnly && <LucideIcon icon={Pencil} color={hexToRgba(theme.colors.primary2, 0.5)} size={16} onClick={() => this.handleEditStep(flowView.FlowStep)} />} 
                        />
                        {
                            stepContent()
                        }
                    </FlexColumn>
                );
            case "Vendor.Docs":
                var stepContent = () => {
                    var { attachments } = vendor || {};
                    attachments = attachments || [];
                    
                    const handleDeleteFile = (uri) => {
                        const currentAttachments = (vendor.attachments || []).filter(item => item.uri !== uri);
                        this.setState({
                            vendor: {
                                ...vendor,
                                attachments: currentAttachments
                            }
                        });
                    };
                    
                    return (
                        <>
                            <FlexColumn gap='16px'>
                                {!readOnly && (
                                    <FlexColumn gap='16px'>
                                        <Text color={theme.colors.defaultLightText}>
                                            Upload documents such as W-9, purchase orders, or any other relevant files.
                                        </Text>
                                        <Flex start>
                                            <Button
                                                permtype="Override"
                                                onClick={() => this.setState({ showUploadModal: true, uploadDoc: {} })}
                                                text='Upload Document'
                                            />
                                        </Flex>
                                    </FlexColumn>
                                )}
                                
                                {(attachments.length > 0) && (
                                    <TableView
                                        id="doc-table"
                                        titleText='Uploaded Documents'
                                        tableLayout='auto'
                                        loading={this.state.loading}
                                        dataSource={attachments}
                                        pagination={false}
                                        rowKey={(record) => record.uri}
                                        borderView
                                        columns={[
                                            {
                                                title: 'File Name',
                                                dataIndex: 'fileName',
                                                render: (text) => <Text>{text}</Text>
                                            },
                                            {
                                                title: 'Type',
                                                dataIndex: 'type',
                                                render: (item) => <Tag tagpreset={theme.colors.secondary8}>{item}</Tag>,
                                                width: '120px'
                                            },
                                            {
                                                title: 'Note',
                                                dataIndex: 'notes',
                                                render: (text) => <Text>{text || '-'}</Text>
                                            },
                                            {
                                                title: 'Action',
                                                width: "100px",
                                                render: (text, item) => (
                                                    <Flex start centerH gap='4px'>
                                                        <SignedLink {...item} viewIcon={<LucideIcon icon={Eye} color={theme.colors.primary2} size={18} />} />
                                                        {!readOnly && (
                                                            <Popconfirm 
                                                                title="Are you sure you want to delete this file?" 
                                                                onConfirm={() => handleDeleteFile(item.uri)}
                                                            >
                                                                <a><LucideIcon icon={Trash} color={theme.colors.primary2} size={18} /></a>
                                                            </Popconfirm>
                                                        )}
                                                    </Flex>
                                                ),
                                                align: "right"
                                            }
                                        ]}
                                    />
                                )}
                                
                                {attachments.length === 0 && (
                                    <Flex centerH centerV style={{ padding: '40px 0', color: theme.colors.defaultLightText }}>
                                        <Text>No documents uploaded yet.</Text>
                                    </Flex>
                                )}
                            </FlexColumn>
                        </>
                    );
                };
                
                return (
                    <FlexColumn gap='16px' start style={{ 
                        border: `1px solid ${hexToRgba(theme.colors.primary2, 0.1)}`, 
                        borderRadius: '8px', 
                        padding: '24px 36px', 
                        width: contentWidth || '850px',
                        minHeight: !readOnly && '500px'
                    }}>
                        <StepHeader 
                            step={flowView.Step} 
                            header={readOnly ? null : flowView.Description} 
                            cta={readOnly && <LucideIcon icon={Pencil} color={hexToRgba(theme.colors.primary2, 0.5)} size={16} onClick={() => this.handleEditStep(flowView.FlowStep)} />} 
                        />
                        {stepContent()}
                    </FlexColumn>
                );
            default:
                return null;
        }
    }
}

function mapStateToProps(state) {
    return {
        aionStore: state.aionAppReducer
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTheme(NewVendor))